import { gql } from '@apollo/client';

export default gql`
  query spaceBilling($billingIntervalType: String) {
    plans(billingIntervalType: $billingIntervalType) {
      plans {
        id
        name
        price
        currency
        billingInterval
        billingIntervalType
        placesLimit
        inspectionSubjectsLimit
        inspectionsLimit
        canSet
      }
    }
    space {
      activePlanEndDate
      activePlan {
        id
        name
        price
        billingInterval
        placesLimit
        inspectionSubjectsLimit
        inspectionsLimit
      }
      billingDetails {
        id
        name
        address
        city
        zipCode
        taxId
        email
      }
      inspectionsTotal
      pendingInspectionsTotal
      inspectionSubjectsTotal
      placesTotal
    }
  }
`;
